module.exports = __webpack_public_path__ + "static/img/b-icon-5-active.3b35f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/b-icon-5-active.png
// module id = NKXR
// module chunks = 0